import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { FlexContainer } from 'features/common/components/FlexContainer';
import { TicketRow } from '../TicketRow';
import { useGetLastEvent } from 'features/BoxOffice/hooks/useGetLastEvent';
import { MultidayRow } from '../MultidayRow/MultidayRow';
import { InformationProps } from 'features/BoxOffice/types';

import { Title, Text, Divider, Total, InnerContainer } from '../OrderPreview.styles';

export const Information = ({ ticketSent }: InformationProps) => {
	const { t } = useTranslation();
	const { watch } = useFormContext();
	const { event, isMultiDay } = useGetLastEvent();
	const { multiday } = useAppSelector(({ lastMultiDay }: RootState) => lastMultiDay);
	const { isPunchup } = useAppSelector(({ auth }: RootState) => auth);

	const handleTicketRow = () =>
		isMultiDay
			? multiday?.map((day) => MultidayRow(day, isPunchup))
			: event?.ticketTypes.map((tt) => TicketRow(tt, isPunchup));

	return (
		<InnerContainer>
			<Title isPunchup={isPunchup}>{t('tickets')}</Title>
			<FlexContainer flexDirection="column" gap="4px">
				{handleTicketRow()}
			</FlexContainer>
			<Divider />
			{ticketSent && (
				<>
					<FlexContainer justifyContent="space-between" alignItems="center" gap="12px">
						<Title isPunchup={isPunchup}>{t('boxOffice-orderNumber')}</Title>
						<Text isPunchup={isPunchup}>{watch('transactionId')}</Text>
					</FlexContainer>
					<Divider />
				</>
			)}
			<FlexContainer justifyContent="space-between" alignItems="center" gap="12px">
				<Title isPunchup={isPunchup}>{t('boxOffice-sendTo')}</Title>
				<Text isPunchup={isPunchup}>{watch('email')}</Text>
			</FlexContainer>
			<Divider />
			<FlexContainer justifyContent="space-between" alignItems="center" gap="12px">
				<Title isPunchup={isPunchup}>{t('total')}</Title>
				<Total element="h1" isPunchup={isPunchup}>
					USD ${watch('total')}
				</Total>
			</FlexContainer>
		</InnerContainer>
	);
};
